export function debug(message: string) {
    if (process.env.ENV !== 'production') {
        console.debug(message);
    }
}